import React, { useEffect, useState } from "react";
import { AntdButton, Inner, Section } from "./styles.js";
import { Typo } from "../../../../../../components/layout/theme/index.js";
import { Form, Select } from "antd";

import { useReport } from "../../../../../../contexts/ReportContext.js";
import { useMatomo } from "@datapunt/matomo-tracker-react";
import { get_cities, get_postal_codes, get_provinces } from "../../../../../../api/endpoints/sysone-endpoints/sysoneEndpoints.js";

const CarLocation = ({ nextSubStep, isMobile }) => {
	const { reportForm, updateReportForm } = useReport();
	const [initialValues, setInitialValues] = useState(null);
	const [provinces, setProvinces] = useState(null)
	const [cities, setCities] = useState(null);
	const [postalCodes, setPostalCodes] = useState(null);
	const [selectedProvinceName, setSelectedProvinceName] = useState(null);
	const [selectedLocalityName, setSelectedLocalityName] = useState(null);
	const [form] = Form.useForm();
	const formValues = Form.useWatch([], form)
	const { trackEvent } = useMatomo();

	useEffect(() => {
		const fetch_initial_values = () => {
			const values = {
				province: reportForm?.carLocation?.province,
				locality: reportForm?.carLocation?.locality,
				postalCode: reportForm?.carLocation?.postalCode,
			};

			setInitialValues(values);
			if (values?.province) {
				fetch_cities(values?.province)
			} if (values?.locality) {
				fetch_postal_codes(values?.locality)
			}
		};
		fetch_initial_values();
		fetch_provinces()

	}, [reportForm]);

	const handleBackStep = () => {
		nextSubStep(reportForm.backStep);
	};

	const handleNextStep = (values) => {
		const updatedValues = {
			province: values.province,
			provinceName: selectedProvinceName,
			locality: values.locality,
			localityName: selectedLocalityName,
			postalCode: values.postalCode,
		};

		trackEvent({
			category: "button-click",
			action: "next-button",
			name: `step1.infoVehicle-(2)location::${JSON.stringify(updatedValues)}`,
		});

		updateReportForm(updatedValues);

		nextSubStep(3);
	};

	useEffect(() => {
		if (initialValues) {
			form.setFieldsValue(initialValues);
		}
	}, [initialValues, form]);

	const fetch_provinces = async () => {
		const res = await get_provinces()
		console.log("RES", res?.provinces)
		setProvinces(res?.provinces || [])
	}

	const fetch_cities = async (p) => {
		const data = await get_cities(p)
		setCities(data.cities || []);

	};

	const fetch_postal_codes = async (c) => {
		const data = await get_postal_codes(c)
		setPostalCodes(data.values || []);
	};

	const onProvinceChange = async (value) => {
		form.setFieldsValue({
			province: value,
			locality: null,
			postalCode: null,
		});
		setPostalCodes(null);
		setCities(null);
		setSelectedLocalityName(null);
		const found = provinces?.find((p) => p.code === value);
		setSelectedProvinceName(found?.name ?? null);
		fetch_cities(value)
	};

	const onCityChange = async (value) => {
		form.setFieldsValue({
			locality: value,
			postalCode: null,
		});
		setPostalCodes(null);
		const found = cities?.find((c) => c.code === value);
		setSelectedLocalityName(found?.name ?? null);
		fetch_postal_codes(value)
	};

	return (
		<Form
			form={form}
			name="car-location-form"
			initialValues={initialValues}
			onFinish={handleNextStep}
		>
			<Inner>
				<Typo level={isMobile ? 3 : 2} style={{ textAlign: "center" }}>
					¿Dónde está tu auto la mayor parte del tiempo?
				</Typo>
				<Section isMobile={isMobile}>
					<Form.Item name="province" style={{ marginBottom: 0 }} rules={[
						{ required: true, message: "Por favor ingrese provincia" },
					]}>
						<Select
							allowClear={true}
							onChange={onProvinceChange}
							showSearch
							placeholder="Provincia"
							optionFilterProp="children"
							filterOption={true}
							style={{ minWidth: "250px" }}
							loading={!provinces}
						>
							{provinces?.map((province) => (
								<Select.Option key={province.code} value={province.code}>
									{province.name}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item name="locality" style={{ marginBottom: 0 }} rules={[
						{ required: true, message: "Por favor ingrese localidad" },
					]}>
						<Select
							allowClear={true}
							onChange={onCityChange}
							disabled={!formValues?.province || !cities}
							showSearch
							placeholder="Localidad"
							optionFilterProp="children"
							filterOption={true}
							style={{ minWidth: "250px" }}
							loading={!cities && formValues?.province}
						>
							{cities?.map((city) => (
								<Select.Option key={city.code} value={city.code}>
									{city.name}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item name="postalCode" style={{ marginBottom: 0 }} rules={[
						{ required: true, message: "Por favor ingrese provincia" },
					]}>
						<Select
							allowClear={true}
							disabled={!formValues?.locality || !postalCodes}
							showSearch
							placeholder="Código Postal"
							optionFilterProp="children"
							filterOption={true}
							style={{ minWidth: "250px" }}
							loading={!postalCodes && formValues?.locality}
						>
							{postalCodes?.map((postalCode) => (
								<Select.Option key={postalCode.number} value={postalCode.number}>
									{postalCode.number}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Section>
				<Section style={{ maxWidth: "250px" }}>
					<AntdButton key="PrevStep1CarLocation" onClick={handleBackStep}>
						<Typo level={5}>Anterior</Typo>
					</AntdButton>
					<Form.Item style={{ marginBottom: 0 }}>
						<AntdButton
							key="NextStep1CarLocation"
							type="primary"
							htmlType="submit"
						>
							<Typo level={5} type="white">
								Siguiente
							</Typo>
						</AntdButton>
					</Form.Item>
				</Section>
			</Inner>
		</Form>
	);
};

export default CarLocation;
